
import type { StyleEventHandlers } from './types/StyleManagerTypes';

export class StyleEventEmitter {
  private shadow: ShadowRoot;
  private handlers: StyleEventHandlers;
  
  constructor(shadow: ShadowRoot, handlers: StyleEventHandlers) {
    this.shadow = shadow;
    this.handlers = handlers;
  }
  
  notifyStylesReady(): void {
    try {
      console.log('[DEBUG] StyleEventEmitter: Notifying styles ready');
      const event = new CustomEvent('onexip-styles-loaded', {
        bubbles: true,
        composed: true
      });
      this.shadow.dispatchEvent(event);
      this.handlers.onStylesReady();
      console.log('[DEBUG] onexip-styles-loaded event dispatched');
    } catch (error) {
      console.error('[ERROR] Error dispatching styles loaded event:', error);
      this.handlers.onStylesError(error as Error);
    }
  }
}
